import { Box, Button, Typography } from '@mui/material'
import ImageBanner from 'components/image-banner'
import SecuritySVG from 'components/svg/security'
import WrapperPermission from 'components/wrapper-permission'
import { useAuth } from 'contexts/auth'
import { useCustomTheme } from 'contexts/theme'
import { useHistory } from 'react-router-dom'
import OrganizationInfo from '../organization-info'
import { useStyles } from './styles'

const ConnectedCertificate = () => {
  const { theme } = useCustomTheme()
  const classes = useStyles()
  const history = useHistory()
  const { user, updateUser } = useAuth()

  const handleNavigateHome = () => {
    if (!user) return
    updateUser({ ...user, emailIsConfirmed: true })
    history.push('/dashboard')
  }

  return (
    <Box className={classes.container}>
      <Box className={classes.mainWrapper}>
        <WrapperPermission>
          <Box className={classes.formBox}>
            <img
              src={theme.name === 'custom' ? theme.logo.base : `/${theme.name}/logo.svg`}
              alt='Logo'
              style={{ maxHeight: 60, width: 'auto', objectFit: 'contain' }}
            />
            <Box className={classes.textContainer}>
              <Typography className={classes.formTitle}>Conexão realizada com sucesso!</Typography>
              <Typography className={classes.formDescription}>
                A conexão com o eSocial foi estabelecida com sucesso! Agora, seu corretor pode realizar os processos com
                mais agilidade. Não se preocupe, ele não terá acesso ao seu certificado digital.
              </Typography>
            </Box>

            <OrganizationInfo
              organizationName={user!.organization?.name as string}
              organizationFederalTaxId={user!.organization?.cnpj as string}
            />
            <Button
              variant='contained'
              fullWidth
              size='large'
              sx={{
                mt: 5,
              }}
              onClick={handleNavigateHome}
            >
              ACESSAR A PLATAFORMA
            </Button>
          </Box>
        </WrapperPermission>
        <ImageBanner
          title='Agora você está conectado ao seu corretor, o que agilizará os processos com mais segurança e tranquilidade para sua empresa.'
          banner={<SecuritySVG />}
        />
      </Box>
    </Box>
  )
}

export default ConnectedCertificate
